module.exports = __webpack_public_path__ + "static/media/calendar_month_selected.1552b8a9.svg";